import React, { useState, useEffect } from "react";
import "./ChatBot.css";
import botIcon from "../image/bot-icon.gif";

import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const moduleConfig = {
  bakery: {
    pdfPath: "/choppies/assets/pdf/bakery/sop_user_guide.pdf",
    headerColor: "#683B12",
  },
  butchery: {
    pdfPath: "/choppies/assets/pdf/butchery/sop_user_guide.pdf",
    headerColor: "#5B2B2D",
  },
  fruitveg: {
    pdfPath: "/choppies/assets/pdf/fruitveg/sop_user_guide.pdf",
    headerColor: "#1a3300",
  },
  cfc: {
    pdfPath: "/choppies/assets/pdf/cfc/sop_user_guide.pdf",
    headerColor: "#212121",
  },
  takeaway: {
    pdfPath: "/choppies/assets/pdf/takeaway/sop_user_guide.pdf",
    headerColor: "#1A150A",
  },
  brmanager: {
    pdfPath: "/choppies/assets/pdf/brmanager/sop_user_guide.pdf",
    headerColor: "#212121",
  },
};

const ChoppiesChatBot = ({ moduleName }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTyping, setIsTyping] = useState(false);

  const { pdfPath, headerColor } =
    moduleConfig[moduleName?.toLowerCase()] || moduleConfig["bakery"];

  // Auto-clear chat on module change
  useEffect(() => {
    setMessages([]);
  }, [moduleName]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessage = { role: "user", content: input };
    setMessages((prev) => [...prev, newMessage]);
    setInput("");
    setIsTyping(true);

    try {
      const loadingTask = pdfjsLib.getDocument(pdfPath);
      const pdf = await loadingTask.promise;

      let fullText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join(" ");
        fullText += pageText + "\n";
      }

      const openRouterResponse = await fetch("https://openrouter.ai/api/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 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`,
        },
        body: JSON.stringify({
          model: "mistralai/mistral-7b-instruct",
          messages: [
            {
              role: "system",
              content:
                "You are a helpful assistant. Answer the user's question clearly and directly using the context, but do not mention the source, the word 'PDF', or restate the question.",
            },
            {
              role: "user",
              content: `Use the following PDF content to answer the question directly, without mentioning the source or repeating the question.\n\nPDF Content:\n${fullText.slice(
                0,
                12000
              )}\n\nQuestion: ${input}`,
            },
          ],
          temperature: 0.4,
        }),
      });

      const data = await openRouterResponse.json();

      const botResponse = {
        role: "assistant",
        content: data.choices?.[0]?.message?.content || "Sorry, I couldn't find an answer.",
      };

      setMessages((prev) => [...prev, botResponse]);
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          content: "Oops! Something went wrong while getting the answer.",
        },
      ]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div className="chatbot-float-container">
      {!isExpanded ? (
        <div className="chatbot-collapsed" onClick={() => setIsExpanded(true)}>
          <img src={botIcon} alt="Chatbot" />
        </div>
      ) : (
        <div className="chatbox">
          <div className="chatbox-header" >
            <span className="chatbox-header-subtitle">ASK KGOTLA</span>
            <span className="chatbox-header-subtitle-lw">Powered by: Lacewood AI engine</span>
            <button
              className="chat-close-btn"
              onClick={() => setIsExpanded(false)}
            >
              ✖
            </button>
          </div>

          <div className="chat-messages">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`chat-message ${
                  msg.role === "user" ? "user-message" : "bot-message"
                }`}
              >
                {msg.content}
              </div>
            ))}

            {isTyping && (
              <div className="chat-message bot-message">
                <span className="typing-dots">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </div>
            )}
          </div>

          <div className="chat-input">
            <input
              type="text"
              placeholder="Ask something..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button onClick={sendMessage}>Send</button>
            <button
              className="chat-clear-btn"
              title="Clear Chat"
              onClick={() => setMessages([])}
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChoppiesChatBot;
